var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"eba0d069e017e64bab55248bfa0c05e01f54e053"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@incept-3d"]={id:"eba0d069e017e64bab55248bfa0c05e01f54e053"};
      